"use client";

import { useOfferCountdownStore } from "@/hooks/use-offer-countdown-store";
import { ReactNode, useLayoutEffect } from "react";

type OfferCountdownProviderProps = {
  children: ReactNode;
};

/**
 * Starts the global offer countdown interval once for the whole app.
 * Mount near the root (e.g. in `Providers`).
 */
export function OfferCountdownProvider({ children }: OfferCountdownProviderProps) {
  useLayoutEffect(() => {
    useOfferCountdownStore.getState().start();
    return () => useOfferCountdownStore.getState().stop();
  }, []);

  return children;
}
